import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState } from '@constants';

import * as actions from '../actions/offer';

const initialState = fromJS({
  codes: {
    filingParty: { data: [], state: null },
    status: { data: [], state: null },
    offerType: { data: [], state: null },
  },
  results: {
    data: [],
    state: null,
    filters: {},
    sortModel: [],
    filterModel: {},
  },
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
  offer: { data: {}, state: null },
  offers: { data: [], state: null },
  file: { data: {}, state: null },
  files: { data: [], state: null },
  searchParam: {
    data: [],
    state: null,
  },
  searchParams: {
    data: [],
    state: null,
  },
  offerSummary: { data: [], state: null },
});

const offerReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_PROPERTY_OFFERS_START: {
      return state.setIn(['offerSummary', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PROPERTY_OFFERS_ERROR: {
      return state.setIn(['offerSummary', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_PROPERTY_OFFERS_SUCCESS: {
      return state
        .setIn(['offerSummary', 'state'], fetchingState.LOADED)
        .setIn(['offerSummary', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.SEARCH_PARAMS_FETCH_START: {
      return state.setIn(['searchParams', 'state'], fetchingState.FETCHING);
    }
    case actions.SEARCH_PARAMS_FETCH_SUCCESS: {
      return state
        .setIn(['searchParams', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParams', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.SEARCH_PARAMS_FETCH_ERROR: {
      return state.setIn(['searchParams', 'state'], fetchingState.ERROR);
    }
    case actions.SEARCH_PARAM_FETCH_START: {
      return state.setIn(['searchParam', 'state'], fetchingState.FETCHING);
    }
    case actions.SEARCH_PARAM_FETCH_SUCCESS: {
      return state
        .setIn(['searchParam', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParam', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.SEARCH_PARAM_FETCH_ERROR: {
      return state.setIn(['searchParam', 'state'], fetchingState.ERROR);
    }
    case actions.SEARCH_PARAM_SET: {
      return state.setIn(
        ['searchParam', 'data'],
        fromJS(
          state
            .getIn(['searchParams', 'data'])
            .toJS()
            .find(v => v.searchParamID === action.searchParamID),
        ),
      );
    }

    case actions.SEARCH_PARAM_RESET: {
      return state.setIn(['searchParam', 'data'], fromJS({}));
    }
    case actions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }
    case actions.SEARCH_SUCCESS: {
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['results', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(['pagination', 'count'], _.get(action, 'data.totalCount', 0));
    }
    case actions.SEARCH_START: {
      return state
        .setIn(['results', 'state'], fetchingState.FETCHING)
        .setIn(['results', 'filters'], fromJS(_.get(action, 'payload', {})))
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize);
    }
    case actions.SEARCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_OFFERS_START: {
      return state.setIn(['offers', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_OFFER_START: {
      return state.setIn(['offer', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_OFFER_START: {
      return state.setIn(['offer', 'state'], fetchingState.FETCHING);
    }
    case actions.UPDATE_OFFER_TAGS_START:
    case actions.UPDATE_OFFER_START: {
      return state.setIn(['offer', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_OFFER_START: {
      return state.setIn(['offer', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_OFFER_FILES_START: {
      return state
        .setIn(['files', 'state'], fetchingState.FETCHING)
        .setIn(['files', 'data'], fromJS([]));
    }
    case actions.FETCH_OFFER_FILE_START: {
      return state.setIn(['file', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_OFFER_FILE_START: {
      return state.setIn(['file', 'state'], fetchingState.FETCHING);
    }
    case actions.UPDATE_OFFER_FILE_START: {
      return state.setIn(['file', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_OFFER_FILE_START: {
      return state.setIn(['file', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_CODEFILE_FILING_PARTY_START: {
      return state.setIn(
        ['codes', 'filingParty', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_CODEFILE_OFFER_STATUS_START: {
      return state.setIn(['codes', 'status', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_CODEFILE_OFFER_TYPE_START: {
      return state.setIn(
        ['codes', 'offerType', 'state'],
        fetchingState.FETCHING,
      );
    }

    case actions.FETCH_OFFERS_SUCCESS: {
      return state
        .setIn(['offers', 'state'], fetchingState.LOADED)
        .setIn(['offers', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_OFFER_SUCCESS: {
      return state
        .setIn(['offer', 'state'], fetchingState.LOADED)
        .setIn(['offer', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.INSERT_OFFER_SUCCESS: {
      return state
        .setIn(['offer', 'state'], fetchingState.LOADED)
        .setIn(['offer', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.UPDATE_OFFER_SUCCESS: {
      return state.setIn(['offer', 'state'], fetchingState.LOADED);
    }
    case actions.UPDATE_OFFER_TAGS_SUCCESS: {
      return state.setIn(
        ['offer', 'data'],
        fromJS({
          ...state.getIn(['offer', 'data']).toJS(),
          tags: _.get(action, 'data.results', []),
        }),
      );
    }
    case actions.DELETE_OFFER_SUCCESS: {
      return state.setIn(['offer', 'state'], fetchingState.LOADED);
    }
    case actions.FETCH_OFFER_FILES_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_OFFER_FILE_SUCCESS: {
      return state
        .setIn(['file', 'state'], fetchingState.LOADED)
        .setIn(['file', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.INSERT_OFFER_FILE_SUCCESS: {
      return state
        .setIn(['file', 'state'], fetchingState.LOADED)
        .setIn(['file', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.UPDATE_OFFER_FILE_SUCCESS: {
      return state.setIn(['file', 'state'], fetchingState.LOADED);
    }
    case actions.DELETE_OFFER_FILE_SUCCESS: {
      return state.setIn(['file', 'state'], fetchingState.LOADED);
    }
    case actions.FETCH_CODEFILE_FILING_PARTY_SUCCESS: {
      return state
        .setIn(['codes', 'filingParty', 'state'], fetchingState.LOADED)
        .setIn(
          ['codes', 'filingParty', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_CODEFILE_OFFER_STATUS_SUCCESS: {
      return state
        .setIn(['codes', 'status', 'state'], fetchingState.LOADED)
        .setIn(
          ['codes', 'status', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_CODEFILE_OFFER_TYPE_SUCCESS: {
      return state
        .setIn(['codes', 'offerType', 'state'], fetchingState.LOADED)
        .setIn(
          ['codes', 'offerType', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case actions.FETCH_OFFERS_ERROR: {
      return state.setIn(['offers', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_OFFER_ERROR: {
      return state.setIn(['offer', 'state'], fetchingState.ERROR);
    }
    case actions.INSERT_OFFER_ERROR: {
      return state.setIn(['offer', 'state'], fetchingState.ERROR);
    }
    case actions.UPDATE_OFFER_ERROR: {
      return state.setIn(['offer', 'state'], fetchingState.ERROR);
    }
    case actions.DELETE_OFFER_ERROR: {
      return state.setIn(['offer', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_OFFER_FILES_ERROR: {
      return state.setIn(['files', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_OFFER_FILE_ERROR: {
      return state.setIn(['file', 'state'], fetchingState.ERROR);
    }
    case actions.INSERT_OFFER_FILE_ERROR: {
      return state.setIn(['file', 'state'], fetchingState.ERROR);
    }
    case actions.UPDATE_OFFER_FILE_ERROR: {
      return state.setIn(['file', 'state'], fetchingState.ERROR);
    }
    case actions.DELETE_OFFER_FILE_ERROR: {
      return state.setIn(['file', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_CODEFILE_FILING_PARTY_ERROR: {
      return state.setIn(
        ['codes', 'filingParty', 'state'],
        fetchingState.ERROR,
      );
    }
    case actions.FETCH_CODEFILE_OFFER_STATUS_ERROR: {
      return state.setIn(['codes', 'status', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_CODEFILE_OFFER_TYPE_ERROR: {
      return state.setIn(['codes', 'offerType', 'state'], fetchingState.ERROR);
    }

    default: {
      return state;
    }
  }
};

export default offerReducer;
